import { createAction } from 'redux-actions'
import querystring from 'querystring'
import { actionCreators as api } from 'reduxBits/api'
import snakeCaseKeys from 'utils/snakeCase'

const prefix = 'Report ad:'
export const REQUEST_CREATE_REPORT_AD = `${prefix} Create report`
export const RECEIVE_CREATE_REPORT_AD = `${prefix} Receive confirmation of report`
export const SET_CONFIRMATION_VISIBILITY = `${prefix} Set the visibility (shown/hidden) of the confirmation modal`
export const SET_REPORT_AD_FORM_ERRORS = `${prefix} Set report form errors`
export const SET_REPORT_AD_VISIBILITY = `${prefix} Set the visibility (shown/hidden) of the report ad form`
export const SAVE_FORM_DATA = `${prefix} Save form data to state`

const requestCreateReportAd = createAction(REQUEST_CREATE_REPORT_AD)
const receiveCreateReportAd = createAction(RECEIVE_CREATE_REPORT_AD)
const showConfirmationModal = createAction(SET_CONFIRMATION_VISIBILITY)
const showReportAd = createAction(SET_REPORT_AD_VISIBILITY)
const saveFormData = createAction(SAVE_FORM_DATA)

const showForm = (payload) => (dispatch, getState) => {
  if (payload) {
    const state = getState()
    if (state.classified.requestedAd.ad.adId === state.reportAd.lastReportAdId) {
      return dispatch(showConfirmationModal(true))
    }
    return dispatch(showReportAd(true))
  }
  return dispatch(showReportAd(false))
}

const reportAd = (formData) => async (dispatch, getState) => {
  const state = getState()
  const { ad } = state.classified.requestedAd
  const { user } = state.account

  const newQuery = snakeCaseKeys({
    name: user.loggedIn ? user.names.formattedName : formData.name.value,
    email: user.loggedIn ? user.email : formData.email.value,
    message: formData.message.value,
    listId: ad.adId,
    supportType: 'abuse',
  })
  dispatch(requestCreateReportAd(newQuery))
  const url = 'blocket/v4/support/tickets'
  try {
    const response = await dispatch(
      api.legacyApiFetch(url, {
        method: 'POST',
        body: querystring.stringify(newQuery),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        },
      }),
    )
    dispatch(showForm(false))
    return dispatch(receiveCreateReportAd({ reportId: response.id, adId: ad.adId }))
  } catch (error) {
    return dispatch(receiveCreateReportAd(error))
  }
}

const saveForm = (formData) => (dispatch) => dispatch(saveFormData(formData))

export const actionCreators = {
  reportAd,
  showConfirmationModal,
  showForm,
  saveForm,
}
